import request from '../../utils/requests'
/** * Tag: Notice */
const baseUrl ="/api/Notice";

/** * 学员微信=上课提醒通知JOB * @param {*} param * { *    hour Desc: Required:false * } */async function _wXSGoToClassNotify(param) {  return request(baseUrl+'/wXSGoToClassNotify',{    method: 'GET',    params: param,  });
}

/** * 学员微信=上课提醒通知JOB（整点通知,orgId=-1时通知全部） * @param {*} param * { *    orgId Desc: Required:false * } */async function _wXSGoToClassNotifyByIntegralPoint(param) {  return request(baseUrl+'/wXSGoToClassNotifyByIntegralPoint',{    method: 'GET',    params: param,  });
}

/** * 老师微信=上课提醒通知JOB * @param {*} param * { *    hour Desc: Required:false * } */async function _wXTGoToClassNotify(param) {  return request(baseUrl+'/wXTGoToClassNotify',{    method: 'GET',    params: param,  });
}

/** * 老师微信=上课提醒通知JOB（整点通知,orgId=-1时通知全部） * @param {*} param * { *    orgId Desc: Required:false * } */async function _wXTGoToClassNotifyByIntegralPoint(param) {  return request(baseUrl+'/wXTGoToClassNotifyByIntegralPoint',{    method: 'GET',    params: param,  });
}

/** * 学员微信=续费提醒通知JOB */async function _renewalReminderNoticeForJob() {  return request(baseUrl+'/renewalReminderNoticeForJob',{    method: 'GET',  });
}

/** * 保险每日投保通知 */async function _insuranceNoticeForJob() {  return request(baseUrl+'/insuranceNoticeForJob',{    method: 'GET',  });
}

/** * 学员微信=续费提醒通知 * @param {*} body * { *    BranchId Desc:校区ID Required:false *    StudentCourse Desc:学员课程 Required:false *    OrgId Desc:机构ID后台使用 Required:false * } */async function _renewalReminderNotice(body) {  return request(baseUrl+'/renewalReminderNotice',{    method: 'POST',    body: body,  });
}

export default{  _wXSGoToClassNotify,  _wXSGoToClassNotifyByIntegralPoint,  _wXTGoToClassNotify,  _wXTGoToClassNotifyByIntegralPoint,  _renewalReminderNoticeForJob,  _insuranceNoticeForJob,  _renewalReminderNotice}



// WEBPACK FOOTER //
// ./src/services/notice.js